import React from 'react';

// The one class component in the codebase — React error boundaries still
// require a class (Standards.md §3.1). Catches render crashes AND lazy-chunk
// load failures (stale chunks after a deploy), offering a reload instead of a
// blank page.
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Route render failed', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const isChunkError = /Loading chunk|dynamically imported module/i.test(
      this.state.error?.message || ''
    );
    return (
      <div className="page">
        <div className="container" style={{ maxWidth: 480, textAlign: 'center', paddingTop: 80 }}>
          <h2 style={{ marginBottom: 12 }}>Something went wrong</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>
            {isChunkError
              ? 'A new version of OpenMat was deployed. Reload to get the latest.'
              : 'An unexpected error occurred. Reloading usually fixes it.'}
          </p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default RouteErrorBoundary;
